import React from 'react';
import { ReserveFormOfficeSelector } from '@/components/reserve/Reserve/controls/ReserveFormOfficeSelector';
import { ReserveFormFloorSelector } from '@/components/reserve/Reserve/controls/ReserveFormFloorSelector';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormFloor: React.FC = () => {
  const { floors } = useReserveForm();
  const isFloorSelectorEnabled = (floors?.length ?? 0) > 1;

  return (
    <div className="grid grid-cols-2 gap-x-2">
      <div className={isFloorSelectorEnabled ? 'col-span-1' : 'col-span-2'}>
        <ReserveFormOfficeSelector />
      </div>
      {isFloorSelectorEnabled ? (
        <div className="col-span-1">
          <ReserveFormFloorSelector />
        </div>
      ) : null}
    </div>
  );
};
